import { cn } from '@lyearn/style';
import { DividerSeparator } from '@lyearn/ui';

import { leftCol } from '../../styles';
import { DetailsLayoutSectionProps } from './types';

const DIVIDER_PROPS = { className: 'bg-interactive-secondary' };

const DetailsLayoutSectionContainer: React.FC<DetailsLayoutSectionProps> = (props) => {
  const { className, sections, dividerClasses } = props;

  return (
    <DividerSeparator
      className={cn(dividerClasses ? dividerClasses : cn('mt-40 ms-20', leftCol), className)}
      direction="col"
      dividerProps={DIVIDER_PROPS}
      gapY={44}>
      {sections}
    </DividerSeparator>
  );
};

export default DetailsLayoutSectionContainer;
